export function getCookie(cname) {
  let name = cname + '=';
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

export function setCookie(cname, cvalue, expireDays = 0) {
  var domainUrl = window.location.host;
  var devLiveAppUrl = 'app' + process.env.VUE_APP_SUFFIX_NAME;
  if (domainUrl != devLiveAppUrl) {
    if (expireDays > 0) {
      const d = new Date();
      d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
      let expires = 'expires=' + d.toUTCString();
      document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
    } else {
      document.cookie = cname + '=' + cvalue + ';path=/';
    }
  }
}

export function removeCookie(cname) {
  document.cookie = cname + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
}

export function checkCookie(cname) {
  let cvalue = getCookie(cname);
  if (cvalue != '') {
    return true;
  } else {
    return false;
  }
}
